import { Alert } from "antd"
import React, { useEffect } from "react"

import { generateDocumentTitle } from "../../../constants/document-title.ts"
import { useAppSelector } from "../../../hooks/use-app-selector.ts"
import {
  selectActiveBranchId,
  selectCompanyIsMultiBranch
} from "../../Branches/redux/branches.slice.ts"
import { AutomationSubTabs } from "../components/common/AutomationSubTabs.tsx"
import { FormFieldRequirementsSettings } from "../components/form-field-requirements/FormFieldRequirementsSettings.tsx"

export default function SettingsFormFieldRequirementsPage() {
  const isMultiBranch = useAppSelector(selectCompanyIsMultiBranch)
  const activeBranchId = useAppSelector(selectActiveBranchId)
  const isBranchScope = isMultiBranch && !!activeBranchId

  useEffect(() => {
    generateDocumentTitle("Settings Required Information")
  }, [])

  return (
    <div className="flex-1 flex flex-col gap-3 w-full">
      <AutomationSubTabs />
      {isBranchScope && (
        <Alert
          type="info"
          showIcon
          message="Required Information is set company-wide and is not yet customizable per branch."
        />
      )}
      <FormFieldRequirementsSettings />
    </div>
  )
}
